<template>
  <div class="div">
    <div class="rectangle-8"></div>
    <div class="group-46">
      <div class="rectangle-9"></div>
      <button class="nav-button prev-button" @click="$router.go(-1)">
        <span>이전</span>
      </button>
    </div>
    <button class="nav-button next-button"
     @click="onClickNext"
     :disabled="!isNextButtonEnabled"
     >
      <span>다음</span>
    </button>
      <div v-for="(num, index) in numbers" :key="`container-${num}`">
        <div 
          :class="['ellipse', `ellipse-${index + 1}`, { 'active': activeNumber === num }]"
          @click="handleNumberClick(num)"
        ></div>
        <div 
          :class="`_${num}`"
          @click="handleNumberClick(num)"
        >{{ num }}</div>
      </div>
    <div 
      class="ellipse ellipse-12"
      @click="deleteNumber"
    >
      <img class="cancelImg" src="/static/salesReservation/cancelNum.png" alt="취소" />
    </div>
    <div class="group-80">
      <div class="rectangle-7"></div>
      <div class="phoneNo">
        <span>
          <span :class="['phoneNo-span', 'phone-1']">
            <span :class="['entered']">{{ phoneNumber1 }}</span>
            <span>{{ phonePlaceholder1 }}</span>
          </span> -
          <span :class="['phoneNo-span', 'phone-2']">
            <span :class="['entered']">{{ phoneNumber2 }}</span>
            <span>{{ phonePlaceholder2 }}</span>
          </span> - 
          <span :class="['phoneNo-span', 'phone-3']">
            <span :class="['entered']">{{ phoneNumber3 }}</span>
            <span>{{ phonePlaceholder3 }}</span>
          </span>
        </span>
      </div>
      <div class="div4">
        정보 입력 후 접수 신청 시 개인정보 활용에 동의한 것으로 간주됩니다.
      </div>
      <div class="div5">
        <span>
          <span class="div-5-span">고객님의 휴대폰 번호</span>를
          <span class="div-5-span2">
            <br />
            입력해주세요.
          </span>
        </span>
      </div>
    </div>
    <div class="rectangle-48"></div>
    <div class="group-92">
      <div class="group-89">
        <div class="div6">
          보험 상담을 신청하고
          <br />
          무료로 커피를 받아가세요!
        </div>
        <div class="event">커피 무료 증정 EVENT</div>
      </div>
      <img class="_6024370-1" src="/static/salesReservation/coffee.png" />
    </div>
    <div class="overlay" v-if="showSelectInsu">
      <SelectInsu 
        v-bind="{ pn, refin, sorce }"
        @close="closeSelectInsu"
        @resetValue="resetValue"
      />
    </div>
  </div>
</template>

<script>
import SelectInsu from './Step1.vue'
export default {
  name: 'ConsultationCard',
  components: {
    SelectInsu
  },
  props: {
    refin: {
      type: String,
      default: ''
    },
    sorce: {
      type: String,
      default: ''
    }
  }, 
  data() {
    return {
      phoneNumber: '010',
      minimumPhoneNumber: '01',
      defaultPhoneNumber: '010',

      phoneNumber1: '',
      phoneNumber2: '',
      phoneNumber3: '',

      phonePlaceholder1: '010',
      phonePlaceholder2: '0000',
      phonePlaceholder3: '0000',

      currentInput: 1,
      activeNumber: null,
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '010', '0'],
      showSelectInsu: false, 
      pn: '' // 전화번호
    };
  },
  computed: {
    isNextButtonEnabled() {
      return (
        this.phoneNumber.length === 11
        // this.phoneNumber1.startsWith('01') &&
        // this.phoneNumber1.length === 3 &&
        // this.phoneNumber2.length === 4 &&
        // this.phoneNumber3.length === 4 &&
        // this.phoneNumber2 !== '0000' &&
        // this.phoneNumber3 !== '0000'
      );
    }
  },

  mounted() {
    this.phoneNumber = this.defaultPhoneNumber;
    this.__renderPhoneNumber();
  },

  methods: {
    __renderPhoneNumber() {
      this.phoneNumber1 = this.phoneNumber.substring(0, 3);
      this.phonePlaceholder1 = '010'.substring(0, 3 - this.phoneNumber1.length);
      this.phoneNumber2 = this.phoneNumber.substring(3, 7);
      this.phonePlaceholder2 = '0000'.substring(0, 4 - this.phoneNumber2.length);
      this.phoneNumber3 = this.phoneNumber.substring(7);
      this.phonePlaceholder3 = '0000'.substring(0, 4 - this.phoneNumber3.length);
    },

    appendNumber(num) {
      if ( 
        ( num === '010' && this.phoneNumber.length >= 3 ) ||
        this.phoneNumber.length >= 11 ) {
        return;
      }
      
      this.phoneNumber = num === '010' ? num : this.phoneNumber + num;
      this.__renderPhoneNumber();
    },

    deleteNumber() {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
      if ( this.phoneNumber <= 2 ) {
        this.phoneNumber = this.minimumPhoneNumber;
      }
      this.__renderPhoneNumber();
    },

    onClickNext() {
      if (this.isNextButtonEnabled) {
        this.pn = `${this.phoneNumber1}${this.phoneNumber2}${this.phoneNumber3}`;
        this.showSelectInsu = true
      }
    },

    closeSelectInsu() {
      this.showSelectInsu = false; 
    },

    handleNumberClick(num) {
      this.activeNumber = num;
      this.appendNumber(num);
    },

    resetValue() {
      this.phoneNumber = this.defaultPhoneNumber;
      this.__renderPhoneNumber();
      
      this.pn = ''
      this.showSelectInsu = false
      // console.log('emit으로 리셋 SalesReservationD');
    }
  }
}
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");

body, .div, .div * {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  box-sizing: border-box;
}

.div {
  background: #ffffff;
  width: 1194px;
  height: 834px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.rectangle-8 {
  background: #184de5;
  border-radius: 50px;
  width: 172px;
  height: 64px;
  position: absolute;
  left: calc(50% - -320px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.group-46 {
  width: 172px;
  height: 64px;
  position: static;
}

.rectangle-9 {
  background: var(--grays-gray-3, #c7c7cc);
  border-radius: 50px;
  width: 172px;
  height: 64px;
  position: absolute;
  left: calc(50% - -128px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.nav-button {
  width: 172px;
  height: 64px;
  border-radius: 50px;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-button span {
  color: #ffffff;
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.03em;
  text-orientation: upright;
}

.nav-button:disabled {
  background-color: var(--grays-gray-3, #c7c7cc);
  cursor: not-allowed;
}

.prev-button {
  left: calc(50% - -128px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.next-button {
  background: #184de5;
  left: calc(50% - -320px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.ellipse {
  background: #ffffff;
  border-radius: 50%;
  border-style: solid;
  border-color: var(--grays-gray-4, #d1d1d6);
  border-width: 2px;
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
}

.ellipse.active {
  border-color: #184de5;
}

.ellipse-1 { left: 725px;  }
.ellipse-2 { left: 857px;  }
.ellipse-3 { left: 989px;  }
.ellipse-4 { left: 725px; top: 125px; }
.ellipse-5 { left: 857px; top: 125px; }
.ellipse-6 { left: 989px; top: 125px; }
.ellipse-7 { left: 725px; top: 245px; }
.ellipse-8 { left: 857px; top: 245px; }
.ellipse-9 { left: 989px; top: 245px; }
.ellipse-10 { left: 725px; top: 365px; }
.ellipse-11 { left: 857px; top: 365px; }
.ellipse-12 {
  left: 989px;
  top: 430px;
  display: flex;
  justify-content: center;
  align-items: center;
}

._1, ._2, ._3, ._4, ._5, ._6, ._7, ._8, ._9, ._0, ._010 {
  color: #000000;
  text-align: center;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  cursor: pointer;
}

._1 { left: 767px; top: 25px; }
._2 { left: 897px; top: 25px; }
._3 { left: 1028px; top: 25px; }
._4 { left: 764px; top: 150px; }
._5 { left: 897px; top: 150px; }
._6 { left: 1028px; top: 150px; }
._7 { left: 765px; top: 270px; }
._8 { left: 896px; top: 270px; }
._9 { left: 1028px; top: 270px; }
._0 { left: 897px; top: 390px; }
._010 { left: 745px; top: 390px; }

.cancelImg {
  width: 50px;
  height: 25px;
  cursor: pointer;
}

.group-80 {
  width: 540px;
  height: 306px;
  position: static;
}

.rectangle-7 {
  background: #ffffff;
  border-radius: 36px;
  border-style: solid;
  border-color: #184de5;
  border-width: 3.5px;
  width: 540px;
  height: 80px;
  position: absolute;
  left: calc(50% - 492px);
  top: calc(50% - 171px); /* -85px - 86px */
}

.phoneNo {
  text-align: left;
  font-size: 42px;
  line-height: 150%;
  letter-spacing: 0.12em;
  font-weight: 500;
  position: absolute;
  left: 157px;
  top: 255px; /* 341px - 86px */
}

.phoneNo-span {
  display: inline-block;
  color: var(--grays-gray-2, #aeaeb2);
}

.phoneNo-span .entered {
  color: #000000;
}

.phoneNo-span.phone-1 {
  width: 86px;
}

.phoneNo-span.phone-2,
.phoneNo-span.phone-3 {
  width: 124px;
}

.div4 {
  color: var(--grays-gray, #8e8e93);
  text-align: left;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  left: 178px;
  top: 340px; /* 426px - 86px */
}

.div5 {
  color: #000000;
  text-align: left;
  font-size: 44px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 400;
  position: absolute;
  left: calc(50% - 492px);
  top: 55px; /* 141px - 86px */
}

.div-5-span {
  font-weight: 600;
}

.div-5-span2 {
  font-weight: 500;
}

.rectangle-48 {
  background: rgba(24, 77, 229, 0.05);
  border-radius: 20px;
  width: 380px;
  height: 148px;
  position: absolute;
  left: 105px;
  top: 489px; /* 575px - 86px */
}

.group-92 {
  width: 309px;
  height: 100px;
  position: static;
}

.group-89 {
  width: 184px;
  height: 76px;
  position: static;
}

.div6 {
  color: #000000;
  text-align: left;
  font-size: 16px;
  line-height: 140%;
  font-weight: 500;
  position: absolute;
  left: 266px;
  top: 557px; /* 643px - 86px */
}

.event {
  color: #000000;
  text-align: left;
  font-size: 20px;
  font-weight: 800;
  position: absolute;
  left: 266px;
  top: 525px; /* 611px - 86px */
}

._6024370-1 {
  border-radius: 20px;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 141px;
  top: 513px; /* 599px - 86px */
  object-fit: cover;
}

.overlay {
  position: absolute; /* fixed에서 absolute로 변경 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
/* 부모 컨테이너에 position: relative 추가 */
.div {
  position: relative;
}
</style>